import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { BrowserModule } from '@angular/platform-browser'
import { FooterComponent } from './page-components/footer/footer.component'
import { FormsModule } from '@angular/forms'
import { HeaderComponent } from './page-components/header/header.component'
import { HomeComponent } from './pages/home/home.component'
import { HttpClientModule } from '@angular/common/http'
import { MenuComponent } from './page-components/menu/menu.component'
import { NgModule } from '@angular/core';
import { ContactComponent } from './pages/contact/contact.component';

@NgModule({
  declarations: [AppComponent, HomeComponent, FooterComponent, MenuComponent, HeaderComponent, ContactComponent],
  imports: [BrowserModule, HttpClientModule, FormsModule, AppRoutingModule],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
